var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445,
    height: 212.261,
    viewBox: "0 0 445 212.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    transform: "translate(1013.904 1006.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M225.166,192.326H14.687A14.687,14.687,0,0,1,0,177.639V39.951A14.686,14.686,0,0,1,14.687,25.265H225.166a14.686,14.686,0,0,1,14.687,14.686V177.639a14.687,14.687,0,0,1-14.687,14.687",
    transform: "translate(-1013.904 -1010.232)",
    fill: "#feade7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307",
    "data-name": "Ellipse 307",
    cx: 3.878,
    cy: 3.878,
    r: 3.878,
    transform: "matrix(0.526, -0.851, 0.851, 0.526, -1005.53, -972.072)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 3.878,
    cy: 3.878,
    r: 3.878,
    transform: "matrix(0.526, -0.851, 0.851, 0.526, -992.478, -972.072)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 3.878,
    cy: 3.878,
    r: 3.878,
    transform: "matrix(0.526, -0.851, 0.851, 0.526, -979.427, -972.072)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M222.249,115.684a13.917,13.917,0,0,0-1.136-18A14.236,14.236,0,0,0,223,96.889a13.995,13.995,0,0,0-.355-24.817c-.028-.014-.061-.021-.09-.036a13.915,13.915,0,0,0-7.436-24.555,14.092,14.092,0,0,0,.933-1.813,13.921,13.921,0,0,0-16.32-18.7,13.94,13.94,0,0,0-21.478-14.1,13.917,13.917,0,0,0-24.968-5.848A13.938,13.938,0,0,0,127.8,10.043a13.95,13.95,0,0,0-22.92,11.571A13.976,13.976,0,0,0,86.4,31.927a13.856,13.856,0,0,0,.915,8.43,13.93,13.93,0,0,0-10.1,23.6A13.948,13.948,0,0,0,75.676,89.57c.028.014.061.021.09.036A13.918,13.918,0,0,0,83.2,114.162a13.895,13.895,0,0,0,15.388,20.511,13.939,13.939,0,0,0,21.478,14.1,13.916,13.916,0,0,0,24.968,5.849A13.938,13.938,0,0,0,170.53,151.6a13.949,13.949,0,0,0,22.911-11.574,13.978,13.978,0,0,0,18.489-10.308,13.87,13.87,0,0,0-.916-8.432,13.931,13.931,0,0,0,11.236-5.6",
    transform: "translate(-1023.926 -1006.506)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M487.971,37.709v73.225a9.441,9.441,0,0,1-9.441,9.441H326.565a9.441,9.441,0,0,1-9.441-9.441V92.861H296.566a5.122,5.122,0,0,1-4.436-7.683l24.994-26.909V37.709a9.441,9.441,0,0,1,9.441-9.441H478.53a9.441,9.441,0,0,1,9.441,9.441",
    transform: "translate(-1056.875 -1010.674)",
    fill: "#ff7bac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M224.772,211.04l-7.861-22.59a52.381,52.381,0,0,0-49.472-35.166H71.663a52.383,52.383,0,0,0-48.911,33.63L13.5,211.04",
    transform: "translate(-1015.895 -1029.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M224.772,211.04l-7.861-22.59a52.381,52.381,0,0,0-49.472-35.166H71.663a52.383,52.383,0,0,0-48.911,33.63L13.5,211.04",
    transform: "translate(-1015.895 -1029.108)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M139.126,48.654c-15.335,14.762-15.051,39.991.633,56.35s40.831,17.654,56.165,2.892,15.051-39.99-.633-56.35-40.831-17.654-56.165-2.892",
    transform: "translate(-1032.749 -1012.165)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M102.725,162h0a32.675,32.675,0,0,0,46.119-2.917l48.128-54.633L162.76,74.312l-61.189,69.457A12.921,12.921,0,0,0,102.725,162",
    transform: "translate(-1028.405 -1017.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M102.725,162h0a32.675,32.675,0,0,0,46.119-2.917l48.128-54.633L162.76,74.312l-61.189,69.457A12.921,12.921,0,0,0,102.725,162Z",
    transform: "translate(-1028.405 -1017.463)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M159.69,80.011a28.527,28.527,0,0,1,33.254-10.663h0a28.515,28.515,0,0,1,17.063,36.538l-1.075,2.961a6.187,6.187,0,0,1-4.2,11.567l-3.75,10.324a28.515,28.515,0,1,1-53.6-19.475l3.228-8.884L146.229,98.5A11.489,11.489,0,0,1,159.69,80.011",
    transform: "translate(-1034.895 -1016.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M159.69,80.011a28.527,28.527,0,0,1,33.254-10.663h0a28.515,28.515,0,0,1,17.063,36.538l-1.075,2.961a6.187,6.187,0,0,1-4.2,11.567l-3.75,10.324a28.515,28.515,0,1,1-53.6-19.475l3.228-8.884L146.229,98.5A11.489,11.489,0,0,1,159.69,80.011Z",
    transform: "translate(-1034.895 -1016.478)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M155.1,88.671a7.215,7.215,0,0,1-.142,7.861",
    transform: "translate(-1036.752 -1019.581)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M188.882,135.631s-5.465-.009-5.883-7.385",
    transform: "translate(-1040.887 -1025.416)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M211.918,111.7a2.436,2.436,0,1,1-.691-3.691,2.679,2.679,0,0,1,.691,3.691",
    transform: "translate(-1044.471 -1022.394)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M213.572,100.262c-.036,1-2.31,1.729-5.079,1.629s-4.984-.992-4.947-1.992,2.31-1.73,5.079-1.629,4.984.992,4.947,1.992",
    transform: "translate(-1043.916 -1020.995)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M182.269,34.919A50.606,50.606,0,0,0,128.886,49.4a12.248,12.248,0,0,0,10.292,4.744,12.493,12.493,0,0,0-.575,1.714,12.343,12.343,0,0,0,16.811,14.2,12.359,12.359,0,0,0,20.715,9.473A12.338,12.338,0,0,0,198.795,81.3a12.347,12.347,0,0,0,18.471.994,50.614,50.614,0,0,0-35-47.376",
    transform: "translate(-1032.908 -1011.29)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M110.068,219.282H98.692l7.337-7.56a16.9,16.9,0,0,1,10.682-5.067c3.608-.309,5.462.984,8.088,5.341l12.809,23.045-5.406.993a11.213,11.213,0,0,1-10.4-3.574Z",
    transform: "translate(-1028.456 -1036.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M110.068,219.282H98.692l7.337-7.56a16.9,16.9,0,0,1,10.682-5.067c3.608-.309,5.462.984,8.088,5.341l12.809,23.045-5.406.993a11.213,11.213,0,0,1-10.4-3.574Z",
    transform: "translate(-1028.456 -1036.97)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M92.514,219.284H81.138l7.336-7.56a16.9,16.9,0,0,1,10.682-5.067A7.814,7.814,0,0,1,107.244,212l10.119,29.326-7.491.384a9.848,9.848,0,0,1-9.275-5.357Z",
    transform: "translate(-1025.868 -1036.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M92.514,219.284H81.138l7.336-7.56a16.9,16.9,0,0,1,10.682-5.067A7.814,7.814,0,0,1,107.244,212l10.119,29.326-7.491.384a9.848,9.848,0,0,1-9.275-5.357Z",
    transform: "translate(-1025.868 -1036.973)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M74.958,219.284H63.582l7.337-7.56A16.9,16.9,0,0,1,81.6,206.658,7.814,7.814,0,0,1,89.689,212l9.146,26.832-7.491.385a9.848,9.848,0,0,1-9.275-5.357Z",
    transform: "translate(-1023.279 -1036.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M74.958,219.284H63.582l7.337-7.56A16.9,16.9,0,0,1,81.6,206.658,7.814,7.814,0,0,1,89.689,212l9.146,26.832-7.491.385a9.848,9.848,0,0,1-9.275-5.357Z",
    transform: "translate(-1023.279 -1036.973)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M58.278,219.284H46.9l7.337-7.56a16.9,16.9,0,0,1,10.682-5.067A7.814,7.814,0,0,1,73.009,212l7.666,23.282-7.491.385a9.848,9.848,0,0,1-9.275-5.357Z",
    transform: "translate(-1020.82 -1036.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M58.278,219.284H46.9l7.337-7.56a16.9,16.9,0,0,1,10.682-5.067A7.814,7.814,0,0,1,73.009,212l7.666,23.282-7.491.385a9.848,9.848,0,0,1-9.275-5.357Z",
    transform: "translate(-1020.82 -1036.973)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M463.568,86.026s-3.384,3.207-12.053-1.738-15.438-18.271-9.188-20.61c15.479-5.789,12.55,19.563-8.963,25.294S394.814,74,396.022,67.549c1.414-7.546,12.358-12.71,18.145-4.143,6.611,9.785-15.73,31.707-31.8,28.851S366.4,80.221,367.108,75.908s4.259-9.056,7.459-8.568c7.619,1.162,11.251,15.23-24.29,15.424",
    transform: "translate(-1065.551 -1015.2)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqheader);
export default __webpack_public_path__ + "static/media/faqheader.d705d6e7a4d97f2de9a5fd131f6c95fa.svg";
export { ForwardRef as ReactComponent };